/* ============
   Existing code (unchanged)
   ============ */

document.addEventListener('change', function (e) {
  if (!e.target.classList.contains('ffp__variant')) return;
  var card = e.target.closest('.ffp__card');
  if (!card) return;
  var input = card.querySelector('input[name="id"]');
  if (input) input.value = e.target.value;
});

function findVariantId(variants, selected) {
  for (var i = 0; i < variants.length; i++) {
    var v = variants[i];
    if (
      (selected[0] == null || v.option1 === selected[0]) &&
      (selected[1] == null || v.option2 === selected[1]) &&
      (selected[2] == null || v.option3 === selected[2])
    ) return v.id;
  }
  return null;
}

function isValueAvailable(variants, index, draft) {
  for (var i = 0; i < variants.length; i++) {
    var v = variants[i];
    var ok =
      (draft[0] == null || v.option1 === draft[0]) &&
      (draft[1] == null || v.option2 === draft[1]) &&
      (draft[2] == null || v.option3 === draft[2]);
    if (ok && v.available) return true;
  }
  return false;
}

document.addEventListener('click', function (e) {
  var pill = e.target.closest('.ffp__pill');
  if (!pill) return;

  var optionEl = pill.closest('.ffp__option');
  var card = pill.closest('.ffp__card');
  var optionsRoot = card.querySelector('.ffp__options');
  if (!optionsRoot) return;

  var variants = [];
  try { variants = JSON.parse(optionsRoot.dataset.variants); } catch(e){}

  var idx = parseInt(optionEl.dataset.optionIndex, 10);
  optionEl.querySelectorAll('.ffp__pill').forEach(function(btn){ btn.classList.remove('is-active'); });
  pill.classList.add('is-active');
  var currentLabel = optionEl.querySelector('.ffp__current');
  if (currentLabel) currentLabel.textContent = pill.dataset.value;

  var selected = [null, null, null];
  card.querySelectorAll('.ffp__option').forEach(function(group){
    var gi = parseInt(group.dataset.optionIndex, 10);
    var active = group.querySelector('.ffp__pill.is-active');
    if (active) selected[gi] = active.dataset.value;
  });

  var id = findVariantId(variants, selected);
  var idInput = card.querySelector('input[name="id"]');
  if (id && idInput) idInput.value = id;

  card.querySelectorAll('.ffp__option').forEach(function(group){
    var gi = parseInt(group.dataset.optionIndex, 10);
    group.querySelectorAll('.ffp__pill').forEach(function(btn){
      var draft = selected.slice();
      draft[gi] = btn.dataset.value;
      var available = isValueAvailable(variants, gi, draft);
      btn.disabled = !available;
    });
  });
});

function ffpFormatMoney(cents) {
  try {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, Shopify.money_format);
    }
  } catch (e) {}

  var n = (parseInt(cents, 10) / 100).toFixed(2);
  var currencySymbol = (window.Shopify && Shopify.currency && Shopify.currency.active)
    ? Shopify.currency.active
    : '{{ shop.currency }}';
  return n + ' ' + currencySymbol;
}

function ffpGetVariants(card) {
  var root = card.querySelector('.ffp__options');
  if (!root || !root.dataset.variants) return [];
  try { return JSON.parse(root.dataset.variants); } catch(e) { return []; }
}

function ffpGetSelectedArray(card) {
  var selected = [null, null, null];
  card.querySelectorAll('.ffp__option').forEach(function(group){
    var gi = parseInt(group.dataset.optionIndex, 10);
    var active = group.querySelector('.ffp__pill.is-active');
    if (active) selected[gi] = active.dataset.value;
  });
  return selected;
}

function ffpFindVariantBySelections(variants, selected) {
  for (var i = 0; i < variants.length; i++) {
    var v = variants[i];
    if (
      (selected[0] == null || v.option1 === selected[0]) &&
      (selected[1] == null || v.option2 === selected[1]) &&
      (selected[2] == null || v.option3 === selected[2])
    ) return v;
  }
  return null;
}

function ffpUpdatePriceForCard(card) {
  var variants = ffpGetVariants(card);
  if (!variants.length) return;

  var idInput = card.querySelector('input[name="id"]');
  var variant = null;
  if (idInput && idInput.value) {
    var vid = parseInt(idInput.value, 10);
    variant = variants.find(function(v){ return v.id === vid; }) || null;
  }

  if (!variant) {
    var selected = ffpGetSelectedArray(card);
    variant = ffpFindVariantBySelections(variants, selected);
  }
  if (!variant) return;

  var priceWrap = card.querySelector('.ffp__price');
  if (!priceWrap) return;

  var html;
  if (variant.compare_at_price && variant.compare_at_price > variant.price) {
    html =
      '<span class="price-item price-item--sale">' + ffpFormatMoney(variant.price) + '</span>' +
      '<span class="price-item price-item--compare">' + ffpFormatMoney(variant.compare_at_price) + '</span>';
  } else {
    html = '<span class="price-item">' + ffpFormatMoney(variant.price) + '</span>';
  }
  priceWrap.innerHTML = html;
}

document.addEventListener('change', function (e) {
  if (!e.target.classList.contains('ffp__variant')) return;
  var card = e.target.closest('.ffp__card');
  if (!card) return;
  ffpUpdatePriceForCard(card);
});

document.addEventListener('click', function (e) {
  var pill = e.target.closest('.ffp__pill');
  if (!pill) return;
  var card = pill.closest('.ffp__card');
  if (!card) return;

  setTimeout(function(){ ffpUpdatePriceForCard(card); }, 0);
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.ffp__card').forEach(ffpUpdatePriceForCard);
});

/* =========================
   ✅ ADD: Scroll reveal logic
   Works with CSS:
   .ffp [data-ffp-reveal] { ... }
   .ffp [data-ffp-reveal].is-in { ... }
   ========================= */

(function () {
  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function markIn(el) {
    if (!el) return;
    el.classList.add('is-in');
  }

  function initFFPReveal() {
    var targets = document.querySelectorAll('.ffp [data-ffp-reveal]');
    if (!targets.length) return;

    // If user prefers reduced motion, just show everything
    if (prefersReducedMotion()) {
      targets.forEach(markIn);
      return;
    }

    // If IO not supported, fallback = show
    if (!('IntersectionObserver' in window)) {
      targets.forEach(markIn);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          markIn(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { root: null, rootMargin: '0px 0px -15% 0px', threshold: 0.15 });

    targets.forEach(function (el) { io.observe(el); });
  }

  // Run once DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFFPReveal);
  } else {
    initFFPReveal();
  }

  // If Shopify theme editor re-renders sections, re-init
  document.addEventListener('shopify:section:load', initFFPReveal);
})();

/* =========================
   ADD: Carousel logic
   - Desktop: 4 per slide
   - Mobile: 1 per slide
   - Incomplete final slide centered
   - Prev / next / dots / swipe
   ========================= */

(function () {
  function FeaturedProductsCarousel(root) {
    this.root = root;
    this.viewport = root.querySelector('[data-ffp-viewport]');
    this.track = root.querySelector('[data-ffp-track]');
    this.prevBtn = root.querySelector('[data-ffp-prev]');
    this.nextBtn = root.querySelector('[data-ffp-next]');
    this.dotsWrap = root.querySelector('[data-ffp-dots]');
    this.cards = [];
    this.pages = [];
    this.currentPage = 0;
    this.perView = 4;
    this.totalPages = 0;
    this.touchStartX = 0;
    this.touchDeltaX = 0;
    this.isDragging = false;
    this.resizeRaf = null;

    if (!this.viewport || !this.track) return;

    this.cards = Array.prototype.slice.call(this.track.querySelectorAll('[data-ffp-card]'));
    if (!this.cards.length) return;

    this.init();
  }

  FeaturedProductsCarousel.prototype.getPerView = function () {
    var mobileMax = parseInt(this.root.getAttribute('data-max-mobile') || '1', 10);
    var desktopMax = parseInt(this.root.getAttribute('data-max-desktop') || '4', 10);
    return window.innerWidth <= 749 ? mobileMax : desktopMax;
  };

  FeaturedProductsCarousel.prototype.chunk = function (items, size) {
    var out = [];
    for (var i = 0; i < items.length; i += size) {
      out.push(items.slice(i, i + size));
    }
    return out;
  };

  FeaturedProductsCarousel.prototype.build = function () {
    var newPerView = this.getPerView();
    var firstVisibleItemIndex = this.currentPage * this.perView;

    this.perView = newPerView;
    this.track.innerHTML = '';

    var groups = this.chunk(this.cards, this.perView);
    for (var i = 0; i < groups.length; i++) {
      var page = document.createElement('div');
      page.className = 'ffp__page';
      page.setAttribute('data-ffp-page', '');

      for (var j = 0; j < groups[i].length; j++) {
        page.appendChild(groups[i][j]);
      }

      this.track.appendChild(page);
    }

    this.pages = Array.prototype.slice.call(this.track.querySelectorAll('[data-ffp-page]'));
    this.totalPages = this.pages.length;

    this.currentPage = Math.floor(firstVisibleItemIndex / this.perView);
    if (this.currentPage > this.totalPages - 1) {
      this.currentPage = Math.max(this.totalPages - 1, 0);
    }

    this.renderDots();
    this.update();
  };

  FeaturedProductsCarousel.prototype.renderDots = function () {
    if (!this.dotsWrap) return;

    this.dotsWrap.innerHTML = '';

    if (this.totalPages <= 1) {
      this.dotsWrap.style.display = 'none';
      return;
    }

    this.dotsWrap.style.display = 'flex';

    for (var i = 0; i < this.totalPages; i++) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'ffp__dot' + (i === this.currentPage ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      dot.setAttribute('data-index', String(i));

      dot.addEventListener('click', this.goTo.bind(this, i));
      this.dotsWrap.appendChild(dot);
    }
  };

  FeaturedProductsCarousel.prototype.updateDots = function () {
    if (!this.dotsWrap) return;
    var dots = this.dotsWrap.querySelectorAll('.ffp__dot');
    dots.forEach(function (dot, index) {
      dot.classList.toggle('is-active', index === this.currentPage);
    }.bind(this));
  };

  FeaturedProductsCarousel.prototype.updateNav = function () {
    if (this.prevBtn) {
      this.prevBtn.disabled = this.currentPage === 0 || this.totalPages <= 1;
    }
    if (this.nextBtn) {
      this.nextBtn.disabled = this.currentPage >= this.totalPages - 1 || this.totalPages <= 1;
    }
  };

  FeaturedProductsCarousel.prototype.update = function () {
    var offset = this.currentPage * 100;
    this.track.style.transform = 'translate3d(-' + offset + '%,0,0)';
    this.updateNav();
    this.updateDots();
  };

  FeaturedProductsCarousel.prototype.goTo = function (index) {
    var nextIndex = Math.max(0, Math.min(index, this.totalPages - 1));
    this.currentPage = nextIndex;
    this.update();
  };

  FeaturedProductsCarousel.prototype.next = function () {
    this.goTo(this.currentPage + 1);
  };

  FeaturedProductsCarousel.prototype.prev = function () {
    this.goTo(this.currentPage - 1);
  };

  FeaturedProductsCarousel.prototype.onPointerStart = function (clientX) {
    this.touchStartX = clientX;
    this.touchDeltaX = 0;
    this.isDragging = true;
  };

  FeaturedProductsCarousel.prototype.onPointerMove = function (clientX) {
    if (!this.isDragging) return;
    this.touchDeltaX = clientX - this.touchStartX;
  };

  FeaturedProductsCarousel.prototype.onPointerEnd = function () {
    if (!this.isDragging) return;

    var threshold = 50;
    if (this.touchDeltaX < -threshold) {
      this.next();
    } else if (this.touchDeltaX > threshold) {
      this.prev();
    }

    this.isDragging = false;
    this.touchStartX = 0;
    this.touchDeltaX = 0;
  };

  FeaturedProductsCarousel.prototype.bind = function () {
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', this.prev.bind(this));
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', this.next.bind(this));
    }

    this.viewport.addEventListener('touchstart', function (event) {
      if (!event.touches || !event.touches.length) return;
      this.onPointerStart(event.touches[0].clientX);
    }.bind(this), { passive: true });

    this.viewport.addEventListener('touchmove', function (event) {
      if (!event.touches || !event.touches.length) return;
      this.onPointerMove(event.touches[0].clientX);
    }.bind(this), { passive: true });

    this.viewport.addEventListener('touchend', function () {
      this.onPointerEnd();
    }.bind(this));

    this.viewport.addEventListener('mousedown', function (event) {
      this.onPointerStart(event.clientX);
    }.bind(this));

    window.addEventListener('mousemove', function (event) {
      this.onPointerMove(event.clientX);
    }.bind(this));

    window.addEventListener('mouseup', function () {
      this.onPointerEnd();
    }.bind(this));

    window.addEventListener('mouseleave', function () {
      this.onPointerEnd();
    }.bind(this));

    window.addEventListener('resize', function () {
      if (this.resizeRaf) window.cancelAnimationFrame(this.resizeRaf);
      this.resizeRaf = window.requestAnimationFrame(function () {
        var newPerView = this.getPerView();
        if (newPerView !== this.perView) {
          this.build();
        } else {
          this.update();
        }
      }.bind(this));
    }.bind(this));
  };

  FeaturedProductsCarousel.prototype.init = function () {
    this.build();
    this.bind();
  };

  function initFFPCarousels(scope) {
    var root = scope || document;
    var carousels = root.querySelectorAll('[data-ffp-root]');
    if (!carousels.length) return;

    carousels.forEach(function (carouselRoot) {
      if (carouselRoot.__ffpCarouselInitialized) return;
      carouselRoot.__ffpCarouselInitialized = true;
      new FeaturedProductsCarousel(carouselRoot);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initFFPCarousels(document);
    });
  } else {
    initFFPCarousels(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initFFPCarousels(event.target);
  });
})();